import Vue from "vue"
import Vuex from "vuex"
//import user from "./user"
import login from "./modules/login"
import permission from "./modules/permission"
import getters from "./getters"
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // user: user,
    login,
    permission
  },
  getters: getters
})
